import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { FiSun, FiMoon, FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollTo = (id) => {
    setMenuOpen(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
  };

  const logoSrc = theme === 'dark' ? '/whitelogo.png' : '/logo.png';

  const navItems = [
    { id: 'about', label: 'About' },
    { id: 'ventures', label: 'Ventures' },
    { id: 'publications', label: 'Publications' },
    { id: 'education', label: 'Education' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <>
      {/* Mobile overlay */}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 10000,
          }}
        />
      )}

      {/* Mobile menu panel */}
      {menuOpen && (
        <div
          style={{
            position: 'fixed',
            top: '72px',
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme === 'dark' ? '#0a0f1c' : '#fafaf9',
            zIndex: 10001,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '48px',
            gap: '32px',
            overflowY: 'auto',
          }}
        >
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
              style={{
                color: theme === 'dark' ? '#e8e6e1' : '#4a4a68',
                fontSize: '1.3rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                textDecoration: 'none',
                padding: '8px 0',
              }}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}

      {/* Navbar */}
      <nav className="navbar" style={{
        boxShadow: scrolled ? 'var(--shadow-sm)' : 'none',
        zIndex: 10002,
        position: 'fixed',
        top: 0, left: 0, right: 0,
      }}>
        <div className="navbar-inner">
          <a href="/" className="nav-logo">
            <img
              src={logoSrc}
              alt="Dr. Nilesh Panchal"
              style={{ height: '48px', width: 'auto', objectFit: 'contain', display: 'block' }}
            />
          </a>

          {/* Desktop nav links */}
          <ul className="nav-links desktop-only">
            {navItems.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`} onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}>
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
                {theme === 'dark' ? <FiSun /> : <FiMoon />}
              </button>
            </li>
          </ul>

          {/* Mobile controls */}
          <div className="mobile-only" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
              {theme === 'dark' ? <FiSun /> : <FiMoon />}
            </button>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--text-primary)',
                fontSize: '1.5rem',
                padding: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {menuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;